import {
  FILTERS_GET_CATEGORIES,
  FILTERS_GET_CURRENT_CATEGORY,
  FILTERS_GET_CURRENT_GROUP,
  FILTERS_GET_DATA,
  FILTERS_GET_ID,
  FILTERS_GET_PARAMS,
  FILTERS_GET_STATE,
  FILTERS_GET_VALUES,
  FILTERS_GET_EXPORT
} from './types';

export const getters = {
  [FILTERS_GET_CURRENT_CATEGORY]: state => {
    return state.filters.currentCategory;
  },
  [FILTERS_GET_CURRENT_GROUP]: state => {
    return state.filters.currentGroup;
  },

  [FILTERS_GET_CATEGORIES]: state => {
    return state.filters.categories;
  },

  [FILTERS_GET_DATA]: state => {
    return state.filters.data;
  },

  [FILTERS_GET_PARAMS]: state => {
    return state.filters.params;
  },

  [FILTERS_GET_VALUES]: state => {
    return state.filters.values;
  },

  [FILTERS_GET_ID]: state => {
    return state.filters.id;
  },

  [FILTERS_GET_STATE]: state => {
    return state.filters;
  },

  [FILTERS_GET_EXPORT]: state => {
    return state.filters.isExportDetail;
  }


};
